export default "__VITE_ASSET__DAMH4Iqk__"